import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[MentionInput]' })
export class MentionInputDirective {
    constructor(el: ElementRef) {
        const style = el.nativeElement.style;
    }
}
